import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PopularBrands from "./component";

const mapStateToProps = ({
    sellOnlineCities: {
        applicableCityForSellOnline
    }
}) => ({
    applicableCityForSellOnline
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PopularBrands);
